export type ComplaintsDropdownType = {
  comId: number;
  comCode: string;
  comName: string;
};

export type HpiType = {
  hpiId: number | null;
  hpiCode: string;
  hpiName: string;
};

export type ComplaintsType = {
  encounterId: string;
  emrComplaintId: number;
  complaintId: number;
  anatomicDetails: string | undefined;
  associatedSymptoms: string | undefined;
  complaints: ComplaintsDropdownType | null;
  context: string | undefined;
  diseaseRelation: string | undefined;
  duration: string | undefined;
  encounterType: string | undefined;
  hpi: HpiType | null;
  laterality: string | undefined;
  location: string | undefined;
  quality: string | undefined;
  severity: string | undefined;
  timing: string | undefined;
  status: boolean;
  doneBy: string;
  date: Date | string;
};

export type ComplaintContextType = {
  list: ComplaintsType[];
  setList: (
    item: ComplaintsType[] | ((item: ComplaintsType[]) => ComplaintsType[])
  ) => void;
  edit: ComplaintsType | null;
  setEdit: (
    item:
      | ComplaintsType
      | null
      | ((item: ComplaintsType | null) => ComplaintsType)
  ) => void;
};

export type ComplaintsPayloadType = {
  emrComplaintId: number;
  complaintId: number | null;
  encounterId: number;
  hpiId: number | null;
  hpiName: string | null;
  hpiData: string | null;
  duration: string;
  location: string;
  context: string;
  quality: string;
  severity: string;
  laterality: string;
  timing: string;
  associatedSymptoms: string;
  diseaseRelation: string;
  encounterType: string;
  anatomicDetails: string;
  status: number;
  isModified: number;
  userType: number;
  revertFlag: false;
  hl7MsgStatus: number;
  ip: string;
  createdId: number;
  createdDate: string;
  clinicId: number;
  newComplaint: string | null;
};

export const complaintsDefaultVslues: ComplaintsType = {
  encounterId: "",
  emrComplaintId: 0,
  complaintId: 0,
  anatomicDetails: "",
  associatedSymptoms: "",
  complaints: null,
  context: "",
  diseaseRelation: "",
  duration: "",
  encounterType: "",
  hpi: null,
  laterality: "",
  location: "",
  quality: "",
  severity: "",
  timing: "",
  status: true,
  doneBy: "",
  date: "",
};

export const prepareComplaintsPayload = (
  data: ComplaintsType
): Omit<
  ComplaintsPayloadType,
  "clinicId" | "createdDate" | "createdId" | "userType"
> => {
  const selectedHpi = data.hpi as HpiType | null;
  const hpiId = selectedHpi?.hpiId ?? null;
  const isNewHpi = hpiId == null && Boolean(selectedHpi?.hpiName?.trim());

  return {
    emrComplaintId: data.emrComplaintId,
    complaintId: data.complaints?.comId as number,
    newComplaint: String(data?.complaints?.comName || ""),
    encounterId: parseInt(data.encounterId),
    hpiId,
    hpiName: null,
    hpiData: isNewHpi ? selectedHpi!.hpiName.trim() : null,
    duration: data.duration || "",
    location: data.location || "",
    context: data.context || "",
    quality: data.quality || "",
    severity: data.severity || "",
    laterality: data.laterality || "",
    timing: data.timing || "",
    associatedSymptoms: data.associatedSymptoms || "",
    diseaseRelation: data.diseaseRelation || "",
    encounterType: data.encounterType || "",
    anatomicDetails: data.anatomicDetails || "",
    status: 1,
    isModified: 0,
    revertFlag: false,
    hl7MsgStatus: 0,
    ip: "",
  };
};

export type ConsultationDetailsType = {
  cptGroupName: string;
  cpt_id: number;
  cpt_code: string;
  cpt_name: string;
  cpt_des: string;
  visitType: number;
};

export type ConsultationCodeType = {
  cpt_id: number;
  cpt_status: number;
  cpt_rate: number;
  cpt_code: string;
  cpt_name: string;
  cpt_des: string;
  cptGroup_id: number;
};

export type VistTypeType = {
  visitType: string;
  id: number;
};
